import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { addAnimationToSprite, MM_ANIMATIONS } from '../AnimationManager';
import GameData from '../data/GameData';
import SoundAssetKeys from '../SoundAssetKeys';

export default class RoundSelectButton extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {string} buttonBg
   * @param {number} roundNum
   */
  constructor(scene, buttonBg, roundNum) {
    super(scene);

    this.isLocked = true;
    this.roundNum = roundNum;
    this.button = ABCyaPhaser.Images.addImage(0,0, buttonBg, this).setOrigin(0);
    if (roundNum > GameData.lastRoundUnlocked) {
      this.lock = this.scene.add.sprite(0,0,ABCyaPhaser.Images.DEFAULT_ATLAS);
      addAnimationToSprite(this.lock, MM_ANIMATIONS, 'locked', true);
      addAnimationToSprite(this.lock, MM_ANIMATIONS, 'opening', false);
      this.lock.x = this.button.width / 2 + this.lock.width / 2;
      this.lock.y = this.button.height / 2 - this.lock.height / 2;
      if (roundNum > 5) {
        this.lock.x = this.lock.x + 10;
        this.lock.y = this.lock.y + 10;
      }

      this.add(this.lock);
      this.scene.sys.updateList.add(this.lock);// bug fix for sprites in containers, they need re-added to the scene's update list
    }
    else {
      this.isLocked = false;
      ABCyaPhaser.Container.setContainerInteractive(this, true);
    }
  }

  unlock () {
    if (this.isLocked) {
      this.lock.play('opening');
      this.isLocked = false;
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._LevelUp, this.scene);
      ABCyaPhaser.Container.setContainerInteractive(this, true);
    }
  }
}